import React, { useContext, useEffect, useState } from 'react';
import ProjectContainer from '../../components/containers/ProjectContainer';
import { Components } from './styled';
import ProjectTableHeader from '../../components/ProjectTableHeader';
import useFormTextState from '../../hooks/useFormTextState';
import ProjectTable from '../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../hooks/useModalState';
import { Campaign } from '../../api/types/campaign';
import { deleteCampaign, getAllCampaigns } from '../../api/campaign';
import CreateOrEditCampaignModal from '../../components/modals/CreateOrEditCampaignModal';

const Campaigns = () => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<Campaign[]>([]);

  const searchProps = useFormTextState();

  const createCampaignModalProps = useModalState<{ campaign?: Campaign & { branchUrlAlias?: string } }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllCampaigns();
    setIsLoading(false);

    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddCampaign = () => {
    createCampaignModalProps.open({});
  };
  const onEditCampaign = (id: string) => {
    const campaign = data?.find((item) => item?.id === id);

    if (campaign) {
      createCampaignModalProps.open({ campaign });
    }
  };

  const onDeleteCampaign = async (id: string) => {
    await deleteCampaign(id);

    await refreshData();
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
    }

    createCampaignModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'name', value: searchProps.value, operatorValue: 'contains' },
  ]);
  return (
    <ProjectContainer title={'Campaigns'}>
      <Components.Container>
        <ProjectTableHeader
          onSearchChange={searchProps.onChangeText}
          searchLabel={'Search by campaign name or ID'}
          searchPlaceholder={'Enter search term'}>
          <Components.SearchBarSeparator />
          <Components.PrimaryButton onClick={onAddCampaign}>Add Campaign</Components.PrimaryButton>
        </ProjectTableHeader>
        <Components.TableWrapper>
          <ProjectTable
            data={data || []}
            columns={tableColumns.campaigns({ onEdit: onEditCampaign, onDelete: onDeleteCampaign })}
            filteringModel={_filteringModel}
            sortingModel={{ field: 'active', sort: 'desc' }}
          />
        </Components.TableWrapper>
      </Components.Container>
      <CreateOrEditCampaignModal
        {...createCampaignModalProps}
        onModalClose={onCreateOrEditModalClose}
        refreshCallback={refreshData}
      />
    </ProjectContainer>
  );
};

export default Campaigns;
